import { render, staticRenderFns } from "./EmailStatus.vue?vue&type=template&id=0550e729&lang=pug"
import script from "./EmailStatus.vue?vue&type=script&lang=js"
export * from "./EmailStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports